import { render, staticRenderFns } from "./canbusCard.vue?vue&type=template&id=ff035534&scoped=true&"
import script from "./canbusCard.vue?vue&type=script&lang=js&"
export * from "./canbusCard.vue?vue&type=script&lang=js&"
import style0 from "./canbusCard.vue?vue&type=style&index=0&id=ff035534&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff035534",
  null
  
)

export default component.exports